"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _DepositTemplateFormComponent = _interopRequireDefault(require("./DepositTemplateFormComponent"));
var _depositWithdrawalSelectors = require("../../redux/selectors/depositWithdrawalSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var submitting = _ref.submitting,
    baseClasses = _ref.baseClasses;
  return {
    template: state.deposit.template,
    product: (0, _depositWithdrawalSelectors.depositProductSelector)(state),
    submitting: submitting,
    baseClasses: baseClasses
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_DepositTemplateFormComponent["default"]);